import { useState } from "react";
import { motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { SectionHeading } from "./Story";

export const Faq = ({ faq }) => {
  const [open, setOpen] = useState(null);
  if (!faq || !faq.enabled || !(faq.items || []).length) return null;

  return (
    <section id="faq" className="py-20 sm:py-28 lg:py-32 bg-[var(--ivory)]" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-8">
        <SectionHeading script="details" title={faq.title || "Good to Know"} testid="faq-heading" />
        <div className="space-y-3">
          {(faq.items || []).map((it, i) => (
            <div key={i} className="rounded-xl border border-[var(--border)] bg-[var(--card)] overflow-hidden" data-testid={`faq-item-${i}`}>
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left"
                data-testid={`faq-question-${i}`}
              >
                <span className="font-medium text-[var(--text-primary)]">{it.q}</span>
                {open === i ? <Minus className="w-4 h-4 text-[var(--gold)] shrink-0" /> : <Plus className="w-4 h-4 text-[var(--gold)] shrink-0" />}
              </button>
              {open === i && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }}
                  className="px-5 pb-5 text-sm text-[var(--text-secondary)] leading-relaxed"
                  data-testid={`faq-answer-${i}`}
                >
                  {it.a}
                </motion.div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
